<style scoped>
.show {
  display: block
}

.none {
  display: none
}
</style>

<template>
  <v-container class="py-5">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <slot></slot>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            single-line
        >
        </v-text-field>
        <v-spacer></v-spacer>
        <div style="margin-right:10px">
          <v-btn
              :class="{show: label === 'Public Holidays', none: label != 'Public Holidays'}"
              :loading="holidayLoading"
              v-on:click="updateHoliday"
          >
            <v-icon class="mr-2">mdi-update</v-icon>
            Update Public Holidays
          </v-btn>
        </div>
        <v-btn
            :class="addLink ? addLink.class || 'primary' : 'primary'"
            :to="addLink ? addLink.url : '/resource/add/' + page"
        >
          <v-icon v-if="addLink && addLink.icon">{{ addLink.icon }}</v-icon>
          <v-icon v-else>mdi-database-plus</v-icon>
          Add {{ label }}
        </v-btn>
      </v-card-title>
      <v-card-subtitle v-if="error_message" class="white--text error">{{
          error_message
        }}
      </v-card-subtitle>
      <v-data-table
          :footer-props="{ 'items-per-page-options': [5, 10, 20, 50] }"
          :headers="headers"
          :items="results"
          :loading="loading"
          :options.sync="options"
          :search="search"
          class="elevation-1"
          style="cursor: pointer; z-index: 111000"
          @click:row="clickIt"
      >
        <template v-slot:item.isActive="{ item }">
          <v-btn
              v-if="!item.code.includes('(deactivated)')"
              class="ma-2 white--text"
              color="error"
              small
              style=" position: 'absolute', elevation: 100,zIndex:100"
              @click="changeStatus(item)"
          >
            <v-icon class="mr-2" dark right>
              mdi-delete
            </v-icon>
            Deactivate
          </v-btn>
          <v-btn
              v-else
              class="ma-2 white--text"
              color="green"
              small
              style=" position: 'absolute', elevation: 100,zIndex:100"
              @click="changeStatus(item)"
          >
            <v-icon class="mr-2" dark right>
              mdi-checkbox-marked-circle-outline
            </v-icon>
            Activate
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
const axios = require('axios');
// const cheerio = require('cheerio');
export default {
  name: "ihris-search-code",
  props: [
    "profile",
    "fields",
    "label",
    "terms",
    "page",
    "resource",
    "add-link",
  ],
  data: function () {
    return {
      debug: "",
      search: "",
      headers: [],
      results: [],
      options: {itemsPerPage: 10},
      loading: false,
      holidayLoading: false,
      total: 0,
      error_message: null,
    };
  },
  watch: {

    /*
    terms: {
      handler() {
        this.getData(true)
      },
      deep: true
    },
    options: {
      handler() {
        this.getData()
      },
      deep: true
    }
    */
  },
  created: function () {
    this.link = this.profile;
    this.getData();
    for (let field of this.fields) {
      this.headers.push({text: field[0], value: field[1]});
    }
    this.headers.push({text: "", value: "isActive"});
  },
  methods: {
    updateHoliday: function () {
      //calculate and determine half year crossover on Ethiopian/Gregorian calendar    
      let currentYear = new Date().getFullYear()
      let currentMonth = new Date().getMonth();
      if (currentMonth > 9) {
        currentYear += 1
      }
      this.holidayLoading = true
      currentYear
      axios
          .get('https://calendarific.com/api/v2/holidays?&api_key=637f9dd90ab7b1324890dca1de4e5e2758866700&country=ET&year=' + currentYear)
          .then(response => {

            let holidays = response.data.response.holidays;
            axios
                .post('/fhir/updatePublicHoliday/', {"data": holidays})
                .then(response => {
                  if (response.data == "alreadyExists") {
                    alert("Sorry data already exists for this year")
                    this.holidayLoading = false
                  } else {
                    this.holidayLoading = false
                    window.location.reload();
                  }

                })
          })
          .catch((err) => console.log(err))
    },
    changeStatus: function (item) {
      let redirectLink = this.$router.history.current.fullPath;
      let url =
          "/fhir/CodeSystem" +
          this.profile.substring(this.profile.lastIndexOf("/"));
      fetch(url)
        .then((response) => {
          if (response.ok) {
            response
              .json()
              .then(async (data) => {
                let updated = data.concept.find(
                  (value) => value.code === item.code
                );
                if (updated.code.includes("(deactivated)")) {
                  updated.code = updated.code.replace("(deactivated)", "");
                  let version = data.version.split(".");
                  ++version[version.length - 1];
                  data.version = version.join(".");
                } else {
                  updated.code = `${updated.code}(deactivated)`;
                  let version = data.version.split(".");
                  ++version[version.length - 1];
                  data.version = version.join(".");
                }
               
                try {
                  await fetch(url, {
                    method: "PUT",
                    headers: {
                      "Content-Type": "application/fhir+json",
                    },
                    body: JSON.stringify(data),
                  });
                  fetch(`/fhir/ValueSet?reference=${data.url}`)
                    .then((response) => {
                      if (response.ok) {
                        response
                          .json()
                          .then(async (res) => {
                            if (res.entry.length > 0) {
                              let data = res.entry[0].resource;
                              let version = data.version.split(".");
                              ++version[version.length - 1];
                              data.version = version.join(".");
                              try {
                                let response = await fetch(
                                  `/fhir/ValueSet/${data.id}`,
                                  {
                                    method: "PUT",
                                    headers: {
                                      "Content-Type": "application/fhir+json",
                                    },
                                    body: JSON.stringify(data),
                                  }
                                );
                                console.log(response)
                                this.$router.push(redirectLink);
                              } catch (error) {
                                console.log(error);
                              }
                            }
                          })
                          .catch((err) => {
                            this.loading = false;
                            this.error_message = "Unable to load results.";
                            console.log(err);
                          });
                      } else {
                        this.loading = false;
                        this.error_message = "Unable to load results.";
                        console.log("Invalid response", response);
                        response
                          .text()
                          .then((body) => {
                            console.log("body text:", body);
                          })
                          .catch((err) => {
                            console.log("Failed to get text:", err);
                          });
                      }
                    })
                    .catch((err) => {
                      this.loading = false;
                      this.error_message = "Unable to load results.";
                      console.log(err);
                    });
                } catch (error) {
                  console.log(error);
                }
              })
              .catch((err) => {
                this.loading = false;
                this.error_message = "Unable to load results.";
                console.log(err);
              });
          } else {
            this.loading = false;
            this.error_message = "Unable to load results.";
            console.log("Invalid response", response);
            response
              .text()
              .then((body) => {
                console.log("body text:", body);
              })
              .catch((err) => {
                console.log("Failed to get text:", err);
              });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.error_message = "Unable to load results.";
          console.log(err);
        });
    },
    clickIt: function (record) {
      this.$router.push({
        name: "resource_view",
        params: {page: this.page, id: record.code},
      });
    },
    getData: function () {
      //console.log("getting data",restart)
      this.loading = true;
      this.error_message = null;
      let url =
          "/fhir/CodeSystem" +
          this.profile.substring(this.profile.lastIndexOf("/"));

      fetch(url)
          .then((response) => {
            if (response.ok) {
              response
                  .json()
                  .then(async (data) => {
                    this.results = [];
                    if (data.concept && data.concept.length > 0) {
                      for (let entry of data.concept) {
                        let result = {
                          code: entry.code,
                          display: entry.display,
                          definition: entry.definition,
                          isActive: true,
                        };
                        if (entry.property && data.property) {
                          for (let prop of data.property) {
                            let property = entry.property.find(
                                (conceptProp) => conceptProp.code === prop.code
                            );
                            if (property) {
                              if (prop.type === "code") {
                                if (property.valueCode) {
                                  result[
                                      prop.code
                                      ] = await this.$fhirutils.codeLookup(
                                      prop.uri,
                                      property.valueCode
                                  );
                                } else {
                                  result[prop.code] = "";
                                }
                              } else if (prop.type === "Coding") {
                                if (property.valueCoding) {
                                  result[
                                      prop.code
                                      ] = await this.$fhirutils.codeLookup(
                                      property.valueCoding.system,
                                      property.valueCoding.code,
                                      prop.uri
                                  );
                                } else {
                                  result[prop.code] = "";
                                }
                              } else {
                                result[prop.code] =
                                    property[
                                    "value" +
                                    prop.type.charAt(0).toUpperCase() +
                                    prop.type.slice(1)
                                        ];
                              }
                            }
                            //result[field[1]] = this.$fhirpath.evaluate(entry.resource, field[1])
                          }
                        }

                        this.results.push(result);
                      }
                    }

                    this.total = data.concept.length;
                    this.loading = false;
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.error_message = "Unable to load results.";
                    console.log(err);
                  });
            } else {
              this.loading = false;
              this.error_message = "Unable to load results.";
              response
                  .text()
                  .then(() => {
                    if (response.status === 401) {
                      this.$router.push("/")
                    }
                  })
                  .catch((err) => {
                    console.log("Failed to get text:", err);
                  });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.error_message = "Unable to load results.";
            console.log(err);
          });
    },
  },
};
</script>
